import { Duration, formatISODuration } from 'date-fns';

import { Defect } from '@/types/Defecten';
import { QueryFunction, useQuery } from '@tanstack/react-query';

import { useFetchWithAuth } from '../useFetchWithAuth';

export const useGetDefecten = (
  isoDuration: Partial<Omit<Duration, 'years' | 'months'>> = { days: 3 },
  refreshInterval?: number,
) => {
  const { fetchWithAuth } = useFetchWithAuth();

  const fetcher: QueryFunction<Defect[]> = async ({ signal }) => {
    const isDefaultDuration = JSON.stringify(isoDuration) === JSON.stringify({ days: 3 });

    const url = isDefaultDuration
      ? `/defecten`
      : `/defecten?periode=${formatISODuration(isoDuration).replace('0M', '').replace('0Y', '')}`;
    const response = await fetchWithAuth(url, { signal });
    if (response.status > 499) {
      throw new Error(`Applicatiefout ${response.status}: ${response.statusText}`);
    } else if (!response.ok) {
      return [];
    } else {
      return response.json();
    }
  };

  return useQuery({
    queryKey: ['alleDefecten'],
    queryFn: fetcher,
    refetchInterval: refreshInterval,
  });
};
